var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#168004",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2206_51202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9948 11.3467C13.9948 10.1784 13.0478 9.23132 11.8795 9.23132C10.7113 9.23132 9.76416 10.1784 9.76416 11.3467C9.76416 12.1334 10.1947 12.8185 10.832 13.183L10.849 20.2874C10.8504 20.8616 11.3163 21.3261 11.8902 21.3261C11.891 21.3261 11.8919 21.3261 11.8927 21.3261C12.4679 21.3248 12.9328 20.8575 12.9314 20.2824L12.9145 13.1906C13.5588 12.828 13.9948 12.1387 13.9948 11.3467Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22345 4.23374L2.7874 2.674C-1.14022 7.81915 -0.872001 15.0201 3.30829 19.8698L4.72782 18.328C1.41133 14.3144 1.17309 8.50483 4.22345 4.23374Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2751 6.46238L4.81892 4.88069C2.12965 8.78707 2.35914 14.0254 5.31662 17.6883L6.74518 16.1366C4.63844 13.3262 4.44158 9.4715 6.2751 6.46238Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83087 10.9913C5.83087 12.61 6.39743 14.1741 7.40922 15.4153L8.83944 13.8618C8.24317 13.0319 7.91331 12.0274 7.91331 10.9913C7.91331 10.2235 8.09213 9.47539 8.42809 8.80082L6.95081 7.19609C6.22404 8.32047 5.83087 9.63421 5.83087 10.9913Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2725 18.328L20.692 19.8698C24.8723 15.0201 25.1405 7.81915 21.2129 2.674L19.7768 4.23388C22.827 8.50483 22.589 14.3144 19.2725 18.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1811 4.88069L17.725 6.46238C19.5585 9.47164 19.3616 13.3262 17.2549 16.1367L18.6834 17.6884C21.6409 14.0254 21.8705 8.78707 19.1811 4.88069Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 10.9913C18.1694 9.63421 17.7761 8.32047 17.0494 7.19609L15.572 8.80082C15.908 9.47539 16.0868 10.2235 16.0868 10.9913C16.0868 12.0274 15.7569 13.0319 15.1606 13.8618L16.5909 15.4153C17.6028 14.1741 18.1694 12.61 18.1694 10.9913Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2206_51202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#168004"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights2);
export default __webpack_public_path__ + "static/media/highlights_2.e3962abe21478c24f98ba42f68054a33.svg";
export { ForwardRef as ReactComponent };